// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "225") return "artifacts/225/5.358.0-c0f72c7-c0f72c7/index.js";
if (chunkId === "102") return "artifacts/102/5.358.0-c0f72c7-c0f72c7/index.js";
  // return url for filenames based on template
  return "chunks/" + chunkId + "." + "3910f8b5" + ".chunk.js"
}